import React, { useState } from "react";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import { MuiSingleDatePicker } from "../muiSingleDatePicker";

export const MuiDataGridDatePicker = ({
    id,
    field,
    value,
    hasFocus,
    onValueChange,
}: GridRenderEditCellParams & {
    onValueChange?: (apiRef: ReturnType<typeof useGridApiContext>, id: string | number, value: string) => void;
}) => {
    const [open, setOpen] = useState(hasFocus);
    const apiRef = useGridApiContext();

    const handleValueChange = async(newValue: string) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: newValue,
        });
        onValueChange?.(apiRef, id, newValue);
    };

    return (
        <MuiSingleDatePicker
            open={open}
            setOpen={(open) => setOpen(open)}
            value={value}
            onChange={(val) => void handleValueChange(val)}
            fullWidth
            disableInputAdornment
            showCloseIcon
            textFieldProps={{
                size: "small",
                variant: "standard",
                sx: { fontSize: "0.875rem" },
            }}
        />
    );
};
